import { defaultTo } from 'ramda';
import { IDepositAmountWidgetResponse } from '../../../../repositories/billing-accounts/v2/deposit-amount-widget';
import { DEFAULT_RESULT } from '../constants';

export const mapResponse200 = (response: IDepositAmountWidgetResponse): string => {
  const { confirmationToken } = response;

  return defaultTo(DEFAULT_RESULT, confirmationToken);
};
